import { render, staticRenderFns } from "./RetailItemList.vue?vue&type=template&id=2bc96dbf&scoped=true&"
import script from "./RetailItemList.vue?vue&type=script&lang=js&"
export * from "./RetailItemList.vue?vue&type=script&lang=js&"
import style0 from "./RetailItemList.vue?vue&type=style&index=0&id=2bc96dbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc96dbf",
  null
  
)

export default component.exports